import tw from "tailwind-styled-components"


export const Inputs = tw.input`
border 
border-gray 
rounded-md 
px-4 
py-1.5
mt-1
shadow
outline-none
`